import React, { Component } from 'react';
import './Zotero.css'
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import Download from '@axetroy/react-download';

export default class Zotero extends Component<any, any> {
  private ref = React.createRef<HTMLDivElement>();

  constructor(props: any) {
    super(props);
    this.state = {
	    index: props.index,
	    error: null,
	    isLoaded: false,
	    group: parseInt(props.group),
	    limit: parseInt(props.limit),
	    start: parseInt(props.start),
	    pagination: props.pagination,
	    loading: props.loading,
	    nbPage: 0,
	    search: props.search,
	    itemType: props.itemType,
	    q: props.q,
	    itemQ: props.itemQ,
	    tag: props.tag,
	    qmode: props.qmode,
	    itemQMode: props.itemQMode,
	    itemTag: props.itemTag,
	    sort: props.sort,
	    direction: props.direction,
	    publications: [] ,
	    page: 1,
	    defaultState: null,
	    scrollAfterLoad: props.scrollAfterLoad
	};
  }
  
  getPublicationsDebounced = AwesomeDebouncePromise(() => {
	  /* See documentation here: https://www.zotero.org/support/dev/web_api/v3/basics#searching */
	var url = 'https://api.zotero.org/groups/'+this.state.group+'/items?format=json&include=data,bibtex,ris&limit='+this.state.limit+'&start='+this.state.start;
	if (this.state.itemType != null) {
	  url += '&itemType='+this.state.itemType;
	}
	if (this.state.q != null) {
	  url += '&q='+this.state.q;
	}
	if (this.state.itemQ != null) {
	  url += '&itemQ='+this.state.itemQ;
	}
	if (this.state.tag != null) {
	  var tags : string [] = [];
	  if (this.state.tag.indexOf(' && ') >= 0) {
		tags = this.state.tag.split(' && ');
	  } else {
		tags.push(this.state.tag);
	  }
	  
	  for (var i = 0; i < tags.length; i++) {
	  	url += '&tag='+tags[i];
	  }
	}
	if (this.state.qmode != null) {
	  url += '&qmode='+this.state.qmode;
	}
	if (this.state.itemQMode != null) {
	  url += '&itemQMode='+this.state.itemQMode;
	}
	if (this.state.itemTag != null) {
	  url += '&itemTag='+this.state.itemTag;
	}
	if (this.state.sort != null) {
	  url += '&sort='+this.state.sort;
	}
	if (this.state.direction != null) {
	  url += '&direction='+this.state.direction;
	}
	
	return fetch(url);
  }, 500);
  
  scrollToRef() {
	if (! this.state.scrollAfterLoad) {
		return;
	}
	
	var top = this.ref.current!.offsetTop - 30;
	window.scrollTo({
	  top: (top < 0 ? 0 : top),
	  behavior: "smooth"
	});
  }
  
  getPublications() {
	this.getPublicationsDebounced()
      .then(res => {
	    var contentType = res.headers.get("content-type");
	    var total = res.headers.get("Total-Results");
	    if (total === null) {
		    total = '0';
	    }
	    var nbPage = Math.ceil(parseInt(total) / this.state.limit);
	    this.setState({
		  nbPage: nbPage
	    });
	    if(contentType && contentType.includes("application/json")) {
	      return res.json();
	    }
	    return res.text();
	  })
      .then(
        (result) => {
	      if (typeof result === "string") {
		    this.setState({
              isLoaded: true,
              page: 1,
              start: 0,
              error: result
            },  () => {
	          this.scrollToRef();
            });
	      } else {
            this.setState({
              isLoaded: true,
              page: (this.state.start / this.state.limit) + 1,
              publications: result
            }, () => {
	          if (this.state.defaultState == null) {
			    this.setState({
			      defaultState: this.state
			    });
			  }
			  this.scrollToRef();
            });
          }
        },
        // Remarque : il est important de traiter les erreurs ici
        // au lieu d'utiliser un bloc catch(), pour ne pas passer à la trappe
        // des exceptions provenant de réels bugs du composant.
        (error) => {
          this.setState({
            isLoaded: true,
            page: 1,
            start: 0,
            error
          }, () => {
	        this.scrollToRef();
          });
        }
      )
  }
  
  componentDidMount() {
	this.getPublications();
  }
  
  nextPage() {
	var start = (this.state.page * this.state.limit);
	this.setState({
		start: start,
		isLoaded: false
	}, this.getPublications);
  }
  
  previousPage() {
	var start = ((this.state.page - 2) * this.state.limit);
	if (start < 0) {
		start = 0;
	}
	this.setState({
		start: start,
		isLoaded: false
	}, this.getPublications);
  }
  
  lastPage() {
	var start = ((this.state.nbPage - 1) * this.state.limit);
	this.setState({
		start: start,
		isLoaded: false
	}, this.getPublications);
  }
  
  firstPage() {
	this.setState({
		start: 0,
		isLoaded: false
	}, this.getPublications);
  }
  
  resetState() {
	var container = document.getElementById("zotero-"+this.state.index);
	if (container !== null) {
		var searchbar = container.getElementsByClassName('searchbar')[0];
		if (searchbar !== null) {
			(searchbar as HTMLInputElement).value = (this.state.defaultState.q !== null ? this.state.defaultState.q : "");
		}
	}
	this.setState(this.state.defaultState, () => {
	  this.setState({
		defaultState: this.state
	  });
	});
  }

  render() {
	const { error, isLoaded, publications, page, pagination, search, q, index, nbPage, loading } = this.state;
    if (error) {
      return <div ref={this.ref} id={"zotero-"+index} className="zotero-error">Erreur : {error}</div>;
    } else {
      return (
	    <div ref={this.ref} id={"zotero-"+index} className="Zotero">
	      {(!isLoaded && loading ?
		  <div className="loading"></div>
		  : "")}
	    
	      {(search ?
	      <div className="search-container">
	        <input className={"searchbar"+(!isLoaded ? " disabled" : "")} type="text" disabled={!isLoaded} value={(q === null ? '' : q)} onChange={(e) => {
		      this.setState({
			    start: 0,
		        q: (e.target as HTMLInputElement).value
	          }, this.getPublications);
	        }}/>
	        {(false ? <button className={"reset-btn"+(!isLoaded ? " disabled" : "")} disabled={!isLoaded} onClick={e => this.resetState()}>Réinitialiser</button> : "")}
	      </div> 
	      : "")}
	      
	      <ul>
            {publications.map(function (publication: any) {
	          var creators = "";
	          if (publication.data.creators !== undefined) {
	            for (var i = 0; i < publication.data.creators.length; i++) {
		          creators += publication.data.creators[i].firstName + " " + publication.data.creators[i].lastName;
		          if (i < publication.data.creators.length - 1) {
			        creators += ", ";
		          }
	            }
	          }
	          
	          var reference = "";
	          if (publication.data.bookTitle !== undefined && publication.data.bookTitle !== "") {
		        reference = publication.data.bookTitle;
	          } else if (publication.data.publicationTitle !== undefined && publication.data.bookTitle !== "") {
		        reference = publication.data.publicationTitle;
	          }
	          
	          if (reference !== "") {
		        if (publication.data.volume !== undefined && publication.data.volume !== "") {
			      reference += ", "+publication.data.volume;
		        }
		        if (publication.data.pages !== undefined && publication.data.pages !== "") {
			      reference += ", "+publication.data.pages;
		        }
	          }
	          
	          return (
	            <li key={publication.key} className={"publication type-"+publication.data.itemType}>
	              <span className="authors">{creators !== "" ? creators+"." : ""}</span>
	              
	              <span className="date">{publication.data.date !== undefined && publication.data.date !== "" ? "("+publication.data.date+")." : ""}</span>
	              
	              <a className="title" target="_blank" rel="noopener noreferrer noindex nofollow" href={publication.data.url}>{publication.data.title}</a>
	              
	              <span className="reference">{(reference !== "" ? reference+"." : "")}</span>
	              
	              <span className="doi">{(publication.data.DOI !== undefined && publication.data.DOI !== "" ? "doi:"+publication.data.DOI : "")}</span>
	              
	              <div className="links">
	                {( publication.data.DOI !== undefined && publication.data.DOI !== "" ?
	                <a className="doi-link" target="_blank" rel="noopener noreferrer noindex nofollow" href={"https://doi.org/"+publication.data.DOI}>DOI</a>
	                : "" )}
	                
	                {( publication.bibtex !== undefined && publication.bibtex !== "" && publication.bibtex !== "\n" ?
	                <Download file={( publication.data.shortTitle !== undefined && publication.data.shortTitle !== "" ? publication.data.shortTitle : publication.data.title )+".bib"} content={publication.bibtex}>
				      <a rel="noopener noreferrer noindex nofollow" className="bibtex-link">BibTeX</a>
				    </Download>
				    : "" )}
        		    
				    {( publication.ris !== undefined && publication.ris !== "" ?
        		    <Download file={( publication.data.shortTitle !== undefined && publication.data.shortTitle !== "" ? publication.data.shortTitle : publication.data.title )+".ris"} content={publication.ris}>
				      <a rel="noopener noreferrer noindex nofollow" className="ris-link">RIS</a>
				    </Download>
				    : "" )}
				  </div>
	            </li>
	          );
            })}
          </ul>
          {(pagination && nbPage > 1 ?
	      <div className="pagination">
	        <button className={"first" + (page <= 1 || !isLoaded ? " disabled" : "")} disabled={(page <= 1 || !isLoaded)} onClick={ e => this.firstPage() }>&lt;&lt;</button>
	        <button className={"prev" + (page <= 1 || !isLoaded ? " disabled" : "")} disabled={(page <= 1 || !isLoaded)} onClick={ e => this.previousPage() }>&lt;</button>
	        <span className="page">Page {page} / {nbPage}</span>
	        <button className={"next" + (page >= nbPage || !isLoaded ? " disabled" : "")} disabled={(page >= nbPage || !isLoaded)} onClick={ e => this.nextPage() }>&gt;</button>
	        <button className={"next" + (page >= nbPage || !isLoaded ? " disabled" : "")} disabled={(page >= nbPage || !isLoaded)} onClick={ e => this.lastPage() }>&gt;&gt;</button>
	      </div> 
	      : "")}
        </div>
      );
    }
  }
}